import {gql} from "@apollo/client";

export const GET_CONFIGURATION_PARAMETERS = gql`
    query ConfiguratieParameters {
        configuratieParameters {
            id
            startDate
            endDate
            amount
            type
        }
    }
`;

export const UPSERT_CONFIGURATION_PARAMETER = gql`
    mutation UpsertConfiguratieParameter($input: ConfigurationParameterInput!) {
        upsertConfiguratieParameter(input: $input) {
            id
            startDate
            endDate
            amount
            type
        }
    }
`;
